export const OPERATIONS_HUB_ONBOARDING = 'Workflows:OperationsHubOnboarding';